/* eslint-disable max-len */
export default {
  criarPlanilha({ commit }, { planilha, colunas, colunasExportar }) {
    const cloneColunas = colunas ? colunas.map(({ label, field, type }) => ({ label, field, type })) : [];
    const cloneColunasExportar = colunasExportar ? colunasExportar.map(({ label, field, type }) => ({ label, field, type })) : [];
    commit('ADD_PLANILHA', { planilha, colunas: cloneColunas, colunasExportar: cloneColunasExportar });
  },
  adicionarColunaExportar({ commit }, { planilha, coluna }) {
    commit('ADD_COLUNA_EXPORTAR', { planilha, coluna });
    commit('REMOVE_COLUNA', { planilha, coluna });
  },
  removerColunaExportar({ commit }, { planilha, coluna }) {
    commit('REMOVE_COLUNA_EXPORTAR', { planilha, coluna });
    commit('ADD_COLUNA', { planilha, coluna });
  },
  adicionarTodosExportar({ commit }, { planilha }) {
    commit('ADD_TODOS_EXPORTAR', { planilha });
    commit('REMOVE_TODOS', { planilha });
  },
  removerTodosExportar({ commit }, { planilha }) {
    commit('ADD_TODOS', { planilha });
    commit('REMOVE_TODOS_EXPORTAR', { planilha });
  },
};
